import http from '@util/http';
import { administrative } from '@api/req';

/**
 * 用章
 */
export async function querySealList(params) {
  return http.get(administrative.GET_SEAL_LIST, params);
}

export async function querySealMyList(params) {
  return http.get(administrative.GET_SEAL_MY, params);
}

export async function queryMySealCheckList(params) {
  return http.get(administrative.GET_SEAL_CHECK, params);
}

export async function querySealOrgStatic(params) {
  return http.get(administrative.GET_SEAL_STATIC_ORG, params);
}

export async function querySealIncubatorStatic(params) {
  return http.get(administrative.GET_SEAL_STATIC_INCUBATOR, params);
}

export async function querySealOrgRecord(params) {
  return http.get(administrative.GET_SEAL_RECORD_ORG, params);
}

export async function querySealInfo(params) {
  return http.get(administrative.GET_SEAL_INFO, params);
}

export async function querySaveSeal(params) {
  return http.post(administrative.SEAL_SAVE, params);
}

export async function queryDeleteSeal(params) {
  return http.get(administrative.SEAL_DELETE, params);
}

export async function queryNextSeal(params) {
  return http.get(administrative.SEAL_NEXT, params);
}

export async function queryNextSealScan(params) {
  return http.post(administrative.SEAL_NEXT_SCAN, params);
}

export async function queryNextSealArchive(params) {
  return http.post(administrative.SEAL_NEXT_ARCHIVE, params);
}

export async function queryReturnSeal(params) {
  return http.post(administrative.SEAL_RETURN, params);
}

export async function queryCallbackSeal(params) {
  return http.get(administrative.SEAL_CALLBACK, params);
}

export async function querySealWorkflow(params) {
  return http.get(administrative.SEAL_WORKFLOW, params);
}



// WEBPACK FOOTER //
// ./src/api/administrative/seal.js